export class TagMatch {
    tagTypeId: number;
    tagTypeName: string;
    tagId: number;
    tagName: string;
    isMatched?: boolean;
}
